/**
 * @generated SignedSource<<78395bfae2c457ba628c9ed4e1ed230f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedBuyerAssurance_user" | "PdpRespSharedItemsRefetchCarousel_user" | "PdpRespSharedPrintDetailsLazy_user" | "PdpRespSimilarAuctionItemsLazy_user" | "PdpRespUnavailableDetailsTabs_user" | "PdpRespUnavailableHeader_user" | "PdpRespUnavailableHeroCarousel_user" | "PdpRespUnavailableSidebarContact_user" | "PdpRespUnavailableSidebarSellerInfo_user" | "PdpSharedItemFavorites_user">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_user";
};
export type PdpRespUnavailableContainer_user$key = {
  readonly " $data"?: PdpRespUnavailableContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeader_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedBuyerAssurance_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemsRefetchCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_user"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedItemFavorites_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespUnavailableSidebarContact_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespUnavailableSidebarSellerInfo_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItemsLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "34a8ded0054844ad9ea530908babc8aa";

export default node;
